import { Syncable } from "shared/state/models/syncable";
import { IAnimalReportSetting } from "shared/api/api";


export const GET_ANIMAL_REPORT_SETTINGS_BY_SITE = 'GET_ANIMAL_REPORT_SETTINGS_BY_SITE';
export const SAVE_ANIMAL_REPORT_SETTING = 'SAVE_ANIMAL_REPORT_SETTING';
export const SYNC_DATA_ANIMAL_REPORT_SETTINGS = 'SYNC_DATA_ANIMAL_REPORT_SETTINGS';
export interface AnimalReportSettingState extends Syncable<IAnimalReportSetting> {}
